// extracted by mini-css-extract-plugin
module.exports = {"welcome_image":"Welcome_welcome_image__1RSvM","body":"Welcome_body__zf9eL","button_wrapper":"Welcome_button_wrapper__1g8yM","footer":"Welcome_footer__36pny"};